import { apiErrorHandler } from '@/helpers/errorHandlers'

import API from '../client'

const fetchCentreProviders = async (params) => {
  const route = `api/centreProviders`
  return API.get(route, { params })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

const addNewCentreProvider = async (data) => {
  const route = `api/centreProviders`
  return API.post(route, data)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

const deleteCentreProvider = async (id) => {
  const route = `api/centreProviders/${id}`
  return API.delete(route)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

const putCentreProvider = async (data) => {
  const route = `api/centreProviders`
  return API.put(route, data)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

export { addNewCentreProvider, deleteCentreProvider, fetchCentreProviders, putCentreProvider }
